import React from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router-dom";

import "@/styles/App.css";
import "@/styles/fonts.css";
import "@/styles/theme.css";
import "/node_modules/react-grid-layout/css/styles.css";
import "/node_modules/react-resizable/css/styles.css";

import initRouter from "./router";
import { initQueryClient } from "./query-client";

const App = () => {
  const [queryClient] = React.useState(() => initQueryClient());
  const [router] = React.useState(() => initRouter(queryClient));

  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  );
};

export default App;
